// extracted by mini-css-extract-plugin
export var banner = "_gl-0";
export var closeButton = "_gl-2";
export var greenCheckmark = "_gl-3";
export var hereLink = "_gl-4";
export var titleIcon = "_gl-1";